/* eslint-disable no-useless-escape */

import * as yup from 'yup';

import { customFieldModules, customFieldFunctions } from '../../hooks/api/useCustomFields'

export const moduleTypes = [
    {
        id: "item",
        display: "Item"
    }
]

export const functionTypes = [
    {
        id: "item",
        display: "Item"
    }
]

export const getCustomFieldsDefinitions = () => {

    let def = []

    Object.keys(customFieldModules).forEach((e1, index) => {
        let name = e1;

        def.push({
            id: e1,
            display: e1,
            value: e1,
            options: Object.keys(customFieldFunctions[name]).map(i => ({ id: customFieldFunctions[name][i], display: i }))
        })

    })

    return def

}

export const inputTypes = [
    {
        id: "textbox",
        display: "Textbox"
    },
    {
        id: "dropdown",
        display: "Dropdown (Single Selection)"
    },
    {
        id: "multi_dropdown",
        display: "Dropdown (Multiple Selection)",
    },
]

export const inputTypesDef = {
    textbox: "textbox",
    dropdown: "dropdown",
    multidropdown: 'multi_dropdown'
}

export const validationSchemaRow = yup.object({
    name: yup
        .string()
        .required('Required')
})

export const validationSchema = yup.object({
    name: yup
        .string()
        .matches(/^[a-zA-Z0-9\_]{4,30}$/g, 'Invalid format (Only A-Z 0-9 with symbol _) : Length 4 - 30')
        .required('Required'),
    module: yup
        .string()
        // .mixed()
        // .oneOf(moduleTypes.map(i => i.id))
        .required('Required'),
    function: yup
        .string()
        // .mixed()
        // .oneOf(functionTypes.map(i => i.id))
        .required('Required'),
    label: yup
        .string()
        .required('Required'),
    description: yup
        .string()
        .required('Required'),
    inputType: yup
        .mixed()
        .oneOf(inputTypes.map(i => i.id))
        .required('Required'),
    // defaultValue: yup
    //     .string()
    //     .required('Required'),
    status: yup
        .bool()
        .required('Required'),
})

export const validationSchemaRows = yup.object({
    rows: yup.array().of(validationSchemaRow)
})

export const initialValuesRow = {
    name: ""
}

export const initialValues = {
    name: "",
    module: "",
    function: "",
    label: "",
    description: "",
    inputType: "",
    defaultValue: "",
    status: true,
    rows: [initialValuesRow],
}
